module.exports = __webpack_public_path__ + "img/hero-earth-04.c5a1e07c.png";